export const QK_HOUSEHOLD_NOTIFICATIONS = 'householdNotifications';
